// extracted by mini-css-extract-plugin
export default {"base":"smart-goals-live_base__+dmUY","entering":"smart-goals-live_entering__UIWSU","match":"smart-goals-live_match__b93Mu"};